(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-court-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // ── Pricing data (LAST_UPDATED: 2026-03-15) ─────────────────────────────
  var PRICING = {
    surfaces: {
      acrylic:        { min: 55,  max: 75,  unit: 'sqft',      label: 'Acrylic Coating' },
      epdm:           { min: 175, max: 175, unit: 'sqft',      label: 'EPDM, 15 mm (about, supplied and installed)' },
      synthetic_turf: { min: 70,  max: 95,  unit: 'sqft',      label: 'Synthetic Turf' }
    },
    bases: {
      pcc:      { min: 85, max: 100, unit: 'sqft', label: 'PCC Base (M20)' },
      asphalt:  { min: 60, max: 75,  unit: 'sqft', label: 'Asphalt Base' },
      existing: { min: 0,  max: 0,   unit: 'sqft', label: 'Existing Base' }
    },
    court_areas: {
      basketball_full:      7200,
      basketball_half:      2300,
      basketball_3x3:       1750,
      badminton:            1300,
      tennis:               7200,
      volleyball:           3800,
      pickleball:           1800,
      cricket:              2200,
      multi_bball_badminton: 7200,
      multi_bball_volleyball: 7200,
      padel_single:          2150,
      padel_double:          4300,
      box_cricket_standard:  1800,
      box_cricket_compact:   800,
      box_cricket_practice:  720
    },
    court_dims: {
      basketball_full:       { l: 120, w: 60 },
      basketball_half:       { l: 60,  w: 40 },
      basketball_3x3:        { l: 50,  w: 35 },
      badminton:             { l: 52,  w: 25 },
      tennis:                { l: 120, w: 60 },
      volleyball:            { l: 80,  w: 48 },
      pickleball:            { l: 60,  w: 30 },
      cricket:               { l: 55,  w: 40 },
      multi_bball_badminton:  { l: 120, w: 60 },
      multi_bball_volleyball: { l: 120, w: 60 },
      padel_single:          { l: 66,  w: 33 },
      padel_double:          { l: 66,  w: 66 },
      box_cricket_standard:  { l: 60,  w: 30 },
      box_cricket_compact:   { l: 40,  w: 20 },
      box_cricket_practice:  { l: 60,  w: 12 }
    },
    addons: {
      fencing:  { min: 150,    max: 250,    unit: 'running_ft', label: 'Chain-Link Fencing (10ft)' },
      lighting: { min: 200000, max: 400000, unit: 'per_court',  label: 'Sports Lighting (LED)' },
      net_post: { min: 15000,  max: 45000,  unit: 'per_court',  label: 'Net & Post Systems' },
      hoops:    { min: 25000,  max: 75000,  unit: 'per_court',  label: 'Basketball Hoops (pair)' },
      cricket_enclosure:  { min: 200000,  max: 400000,  unit: 'per_court', label: 'Box Cricket Enclosure (steel + netting)' }
    }
  };

  var VARIANTS = {
    basketball:  [
      { value: 'basketball_full',  label: 'Full Court (FIBA) — 7,200 sqft' },
      { value: 'basketball_half',  label: 'Half Court — 2,300 sqft' },
      { value: 'basketball_3x3',   label: '3×3 Court — 1,750 sqft' }
    ],
    badminton:   [{ value: 'badminton', label: 'Singles / Doubles — 1,300 sqft' }],
    tennis:      [{ value: 'tennis',    label: 'Full Court (ITF) — 7,200 sqft' }],
    volleyball:  [{ value: 'volleyball', label: 'Full Court (FIVB) — 3,800 sqft' }],
    pickleball:  [{ value: 'pickleball', label: 'Full Court (IFP) — 1,800 sqft' }],
    cricket:     [{ value: 'cricket',    label: 'Standard Pitch — 2,200 sqft' }],
    multi_sport: [
      { value: 'multi_bball_badminton',  label: 'Basketball + 2 Badminton — 7,200 sqft' },
      { value: 'multi_bball_volleyball', label: 'Basketball + Volleyball — 7,200 sqft' }
    ],
    padel: [
      { value: 'padel_single', label: 'Single Court — 2,150 sqft' },
      { value: 'padel_double', label: 'Double Court (2 side-by-side) — 4,300 sqft' }
    ],
    box_cricket: [
      { value: 'box_cricket_standard', label: 'Standard Box (60×30ft) — 1,800 sqft' },
      { value: 'box_cricket_compact',  label: 'Compact Box (40×20ft) — 800 sqft' },
      { value: 'box_cricket_practice', label: 'Practice Nets (2-lane) — 720 sqft' }
    ]
  };

  // Surface compatibility per sport
  var SURFACE_COMPAT = {
    basketball:   ['acrylic', 'epdm'],
    badminton:    ['acrylic'],
    tennis:       ['acrylic'],
    volleyball:   ['acrylic'],
    pickleball:   ['acrylic'],
    cricket:      ['synthetic_turf'],
    multi_sport:  ['acrylic', 'epdm'],
    padel:        ['synthetic_turf'],
    box_cricket:  ['synthetic_turf']
  };

  // ── Indian number formatting ─────────────────────────────────────────────
  function formatINR(num) {
    var str = Math.round(num).toString();
    var lastThree = str.substring(str.length - 3);
    var remaining = str.substring(0, str.length - 3);
    if (remaining !== '') lastThree = ',' + lastThree;
    return '\u20B9' + remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
  }

  // ── Init all calculator instances ───────────────────────────────────────
  document.querySelectorAll('.cc-court-calculator').forEach(function (section) {
    initCalculator(section);
  });

  function initCalculator(section) {
    var id = section.id.replace('cc-court-calculator-', '');

    // State
    var state = {
      step:    1,
      sport:   null,
      count:   1,
      variant: null,
      surface: null,
      base:    null,
      addons:  []
    };

    // DOM refs — scoped to this section instance
    var bar       = section.querySelector('#cc-calc-bar-' + id);
    var stepsEl   = section.querySelector('#cc-calc-steps-' + id);
    var navEl     = section.querySelector('#cc-calc-nav-' + id);
    var backBtn   = section.querySelector('#cc-calc-back-' + id);
    var nextBtn   = section.querySelector('#cc-calc-next-' + id);
    var resultEl  = section.querySelector('#cc-calc-result-' + id);
    var rangeEl   = section.querySelector('#cc-calc-range-' + id);
    var areaEl    = section.querySelector('#cc-calc-area-' + id);
    var breakEl   = section.querySelector('#cc-calc-breakdown-' + id);
    var resetBtn  = section.querySelector('#cc-calc-reset-' + id);
    var countVal  = section.querySelector('#cc-calc-count-' + id);
    var decBtn    = section.querySelector('#cc-calc-count-dec-' + id);
    var incBtn    = section.querySelector('#cc-calc-count-inc-' + id);
    var variantSel = section.querySelector('#cc-calc-variant-' + id);
    var hoopsLabel = section.querySelector('#cc-calc-hoops-label-' + id);
    var padelLabel = section.querySelector('#cc-calc-padel-structure-label-' + id);
    var cricketEncLabel = section.querySelector('#cc-calc-cricket-enclosure-label-' + id);
    var padelPanel = section.querySelector('#cc-calc-padel-' + id);
    function showPadelPanel(on) {
      if (!padelPanel) return;
      padelPanel.hidden = !on;
      if (navEl) { navEl.hidden = on; navEl.style.display = on ? 'none' : ''; }  // CSS display overrides [hidden]
    }

    // ── Sport card click ─────────────────────────────────────────────────
    section.querySelectorAll('.cc-court-calculator__sport-card').forEach(function (card) {
      card.addEventListener('click', function () {
        section.querySelectorAll('.cc-court-calculator__sport-card').forEach(function (c) {
          c.classList.remove('--selected');
          c.setAttribute('aria-selected', 'false');
        });
        card.classList.add('--selected');
        card.setAttribute('aria-selected', 'true');
        state.sport = card.dataset.sport;
        state.variant = null;
        state.surface = null;
        setNextEnabled(true);
        showPadelPanel(state.sport === 'padel');
      });
    });

    // ── Counter ──────────────────────────────────────────────────────────
    decBtn.addEventListener('click', function () { updateCount(-1); });
    incBtn.addEventListener('click', function () { updateCount(1); });

    function updateCount(delta) {
      var next = state.count + delta;
      if (next < 1 || next > 4) return;
      state.count = next;
      countVal.textContent = state.count;
      decBtn.disabled = state.count === 1;
      incBtn.disabled = state.count === 4;
    }

    // ── Variant select ───────────────────────────────────────────────────
    variantSel.addEventListener('change', function () {
      state.variant = variantSel.value;
    });

    // ── Surface card click ───────────────────────────────────────────────
    section.querySelectorAll('.cc-court-calculator__surface-card').forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.classList.contains('--disabled')) return;
        section.querySelectorAll('.cc-court-calculator__surface-card').forEach(function (c) {
          c.classList.remove('--selected');
          c.setAttribute('aria-selected', 'false');
        });
        card.classList.add('--selected');
        card.setAttribute('aria-selected', 'true');
        state.surface = card.dataset.surface;
        setNextEnabled(true);
      });
    });

    // ── Base radio ───────────────────────────────────────────────────────
    section.querySelectorAll('.cc-court-calculator__base-radio').forEach(function (radio) {
      radio.addEventListener('change', function () {
        state.base = radio.value;
        setNextEnabled(true);
      });
    });

    // ── Addon checkboxes ─────────────────────────────────────────────────
    section.querySelectorAll('.cc-court-calculator__addon-check').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var addon = cb.dataset.addon;
        if (cb.checked) {
          if (state.addons.indexOf(addon) === -1) state.addons.push(addon);
        } else {
          state.addons = state.addons.filter(function (a) { return a !== addon; });
        }
      });
    });

    // ── Navigation ───────────────────────────────────────────────────────
    nextBtn.addEventListener('click', function () {
      if (state.sport === 'padel') return;  // padel is priced per court: no per-sq-ft steps
      if (state.step < 5) {
        goToStep(state.step + 1);
      } else {
        showResult();
      }
    });

    backBtn.addEventListener('click', function () {
      if (state.step > 1) goToStep(state.step - 1);
    });

    resetBtn.addEventListener('click', function () { reset(); });

    // ── goToStep ─────────────────────────────────────────────────────────
    function goToStep(n) {
      // Prepare step on arrival
      if (n === 2 && state.sport) populateVariants();
      if (n === 3 && state.sport) filterSurfaces();
      if (n === 2) {
        // Show/hide hoops based on sport
        if (hoopsLabel) {
          hoopsLabel.style.display = (state.sport === 'basketball' || state.sport === 'multi_sport') ? '' : 'none';
        }
      }
      if (n === 5) {
        if (hoopsLabel) hoopsLabel.style.display = (state.sport === 'basketball' || state.sport === 'multi_sport') ? '' : 'none';
        if (padelLabel) padelLabel.style.display = (state.sport === 'padel') ? '' : 'none';
        if (cricketEncLabel) cricketEncLabel.style.display = (state.sport === 'box_cricket') ? '' : 'none';
      }

      stepsEl.querySelectorAll('.cc-court-calculator__step').forEach(function (step) {
        var stepNum = parseInt(step.dataset.step, 10);
        if (stepNum === n) {
          step.removeAttribute('hidden');
        } else {
          step.setAttribute('hidden', '');
        }
      });

      state.step = n;

      // Progress bar
      var pct = (n / 5) * 100;
      bar.style.width = pct + '%';
      section.querySelector('.cc-court-calculator__progress').setAttribute('aria-valuenow', n);

      // Step labels
      section.querySelectorAll('.cc-court-calculator__progress-step').forEach(function (label) {
        var stepN = parseInt(label.dataset.stepLabel, 10);
        label.classList.remove('--active', '--done');
        if (stepN === n) label.classList.add('--active');
        if (stepN < n)  label.classList.add('--done');
      });

      // Back button
      if (n > 1) backBtn.removeAttribute('hidden');
      else backBtn.setAttribute('hidden', '');

      // Next button label
      nextBtn.textContent = n === 5 ? 'Calculate' : 'Next';

      // Enable/disable next based on current step state
      setNextEnabled(stepIsComplete(n));
    }

    function stepIsComplete(n) {
      if (n === 1) return state.sport !== null;
      if (n === 2) return state.count >= 1 && state.variant !== null;
      if (n === 3) return state.surface !== null;
      if (n === 4) return state.base !== null;
      if (n === 5) return true; // addons are optional
      return false;
    }

    function setNextEnabled(enabled) {
      nextBtn.disabled = !enabled;
    }

    // ── Populate variants dropdown ────────────────────────────────────────
    function populateVariants() {
      var opts = VARIANTS[state.sport] || [];
      variantSel.innerHTML = '';
      opts.forEach(function (opt) {
        var el = document.createElement('option');
        el.value = opt.value;
        el.textContent = opt.label;
        variantSel.appendChild(el);
      });
      state.variant = opts.length ? opts[0].value : null;
      variantSel.value = state.variant;
    }

    // ── Filter surface cards ──────────────────────────────────────────────
    function filterSurfaces() {
      var allowed = SURFACE_COMPAT[state.sport] || [];
      section.querySelectorAll('.cc-court-calculator__surface-card').forEach(function (card) {
        var surf = card.dataset.surface;
        var compatible = allowed.indexOf(surf) !== -1;
        if (compatible) {
          card.classList.remove('--disabled');
          card.removeAttribute('aria-disabled');
        } else {
          card.classList.add('--disabled');
          card.classList.remove('--selected');
          card.setAttribute('aria-selected', 'false');
          card.setAttribute('aria-disabled', 'true');
        }
      });
      // Clear surface selection if incompatible
      if (state.surface && allowed.indexOf(state.surface) === -1) {
        state.surface = null;
      }
    }

    // ── Calculate ─────────────────────────────────────────────────────────
    function calculate() {
      var variant   = state.variant || 'basketball_full';
      var area      = (PRICING.court_areas[variant] || 0) * state.count;
      var dims      = PRICING.court_dims[variant] || { l: 0, w: 0 };
      var perim     = 2 * (dims.l + dims.w) * state.count;

      var surface   = PRICING.surfaces[state.surface];
      var base      = PRICING.bases[state.base];

      var lines = [];
      var totalMin = 0;
      var totalMax = 0;

      // Surface
      if (surface) {
        var sMin = surface.min * area;
        var sMax = surface.max * area;
        totalMin += sMin; totalMax += sMax;
        lines.push({ label: surface.label + ' (' + area.toLocaleString('en-IN') + ' sqft)', minV: sMin, maxV: sMax });
      }

      // Base
      if (base && base.min > 0) {
        var bMin = base.min * area;
        var bMax = base.max * area;
        totalMin += bMin; totalMax += bMax;
        lines.push({ label: base.label + ' (' + area.toLocaleString('en-IN') + ' sqft)', minV: bMin, maxV: bMax });
      } else if (base && base.min === 0) {
        lines.push({ label: base.label, minV: 0, maxV: 0, note: 'Included (existing)' });
      }

      // Addons
      state.addons.forEach(function (key) {
        var addon = PRICING.addons[key];
        if (!addon) return;
        var aMin, aMax;
        if (addon.unit === 'running_ft') {
          aMin = addon.min * perim;
          aMax = addon.max * perim;
        } else {
          aMin = addon.min * state.count;
          aMax = addon.max * state.count;
        }
        totalMin += aMin; totalMax += aMax;
        lines.push({ label: addon.label, minV: aMin, maxV: aMax });
      });

      return { lines: lines, totalMin: totalMin, totalMax: totalMax, area: area };
    }

    // ── Show result ───────────────────────────────────────────────────────
    function showResult() {
      var result = calculate();

      rangeEl.textContent = formatINR(result.totalMin) + ' \u2013 ' + formatINR(result.totalMax);
      areaEl.textContent  = 'Total area: ' + result.area.toLocaleString('en-IN') + ' sqft \u00B7 ' + state.count + ' court' + (state.count > 1 ? 's' : '');

      var html = '';
      result.lines.forEach(function (line) {
        var valStr = line.note
          ? '<span class="cc-court-calculator__breakdown-value">' + line.note + '</span>'
          : '<span class="cc-court-calculator__breakdown-value">' + formatINR(line.minV) + ' \u2013 ' + formatINR(line.maxV) + '</span>';
        html += '<div class="cc-court-calculator__breakdown-item">'
          + '<span class="cc-court-calculator__breakdown-label">' + line.label + '</span>'
          + valStr
          + '</div>';
      });
      // Total row
      html += '<div class="cc-court-calculator__breakdown-item --total">'
        + '<span class="cc-court-calculator__breakdown-label">Total (indicative)</span>'
        + '<span class="cc-court-calculator__breakdown-value">' + formatINR(result.totalMin) + ' \u2013 ' + formatINR(result.totalMax) + '</span>'
        + '</div>';

      breakEl.innerHTML = html;

      // Swap visibility
      stepsEl.setAttribute('hidden', '');
      navEl.setAttribute('hidden', '');
      resultEl.removeAttribute('hidden');
      resultEl.focus();
    }

    // ── Reset ─────────────────────────────────────────────────────────────
    function reset() {
      state.step    = 1;
      state.sport   = null;
      state.count   = 1;
      state.variant = null;
      state.surface = null;
      state.base    = null;
      state.addons  = [];

      // Clear UI selections
      section.querySelectorAll('.cc-court-calculator__sport-card').forEach(function (c) {
        c.classList.remove('--selected');
        c.setAttribute('aria-selected', 'false');
      });
      section.querySelectorAll('.cc-court-calculator__surface-card').forEach(function (c) {
        c.classList.remove('--selected', '--disabled');
        c.setAttribute('aria-selected', 'false');
        c.removeAttribute('aria-disabled');
      });
      section.querySelectorAll('.cc-court-calculator__base-radio').forEach(function (r) { r.checked = false; });
      section.querySelectorAll('.cc-court-calculator__addon-check').forEach(function (c) { c.checked = false; });
      countVal.textContent = '1';
      decBtn.disabled = true;
      incBtn.disabled = false;

      resultEl.setAttribute('hidden', '');
      showPadelPanel(false);
      stepsEl.removeAttribute('hidden');
      navEl.removeAttribute('hidden');

      goToStep(1);
    }

    // ── Bootstrap ─────────────────────────────────────────────────────────
    decBtn.disabled = true; // count starts at 1
    goToStep(1);

    // ── Phase 1 Extension: product context + localStorage + WhatsApp + GST + emit
    // Wired after core init so it can read state safely. See:
    // tools/theme-tdd/test_calculator_pure.js
    initExtensions(section, state, calculate, goToStep);
  }

  // ─── Phase 1 Extensions (pure-function helpers, see test_calculator_pure.js)
  // These mirror the functions tested in node — keep behavior in sync.

  function ccIsAsphaltAvailable(area, minSqft) {
    var t = (minSqft == null || minSqft <= 0) ? 5000 : minSqft;
    return area >= t;
  }

  function ccApplyGST(amount, inclusive, rate) {
    var r = (rate == null) ? 0.18 : rate;
    return inclusive
      ? { subtotal: amount, gst: Math.round(amount * r), total: Math.round(amount * (1 + r)) }
      : { subtotal: amount, gst: Math.round(amount * r), total: amount };
  }

  function ccIsExistingBase(v) {
    if (v == null) return false;
    var s = String(v).toLowerCase();
    return s.indexOf('existing') !== -1;
  }

  function ccBuildWhatsAppUrl(opts) {
    var lines = [];
    lines.push('Hi ChampCourts! I just used the cost calculator on your ' + (opts.productTitle || 'sports court') + ' page.');
    lines.push('');
    lines.push('My configuration:');
    if (opts.sport)   lines.push('Sport: ' + opts.sport);
    if (opts.surface) lines.push('Surface: ' + opts.surface);
    if (opts.base)    lines.push('Base: ' + opts.base);
    if (opts.count)   lines.push('Courts: ' + opts.count);
    if (opts.area)    lines.push('Total area: ' + opts.area.toLocaleString('en-IN') + ' sqft');
    if (opts.addons && opts.addons.length) lines.push('Add-ons: ' + opts.addons.join(', '));
    lines.push('');
    if (opts.totalMin != null && opts.totalMax != null) {
      lines.push('Estimate (ex-GST): ' + formatINR(opts.totalMin) + ' - ' + formatINR(opts.totalMax));
    }
    lines.push('');
    lines.push('Please share a detailed estimate and let me know site visit availability.');
    return 'https://wa.me/' + (opts.phone || '919258775187') + '?text=' + encodeURIComponent(lines.join('\n'));
  }

  var CC_STORAGE_KEY = 'cc-calc-state-v1';
  var CC_STORAGE_MAX_AGE_MS = 30 * 24 * 3600 * 1000; // 30 days

  function ccLoadState(storage) {
    try {
      var raw = storage.getItem(CC_STORAGE_KEY);
      if (!raw) return null;
      var p = JSON.parse(raw);
      if (!p || typeof p !== 'object') return null;
      if (p.savedAt && (Date.now() - p.savedAt) > CC_STORAGE_MAX_AGE_MS) return null;
      return p.state || null;
    } catch (e) { return null; }
  }

  function ccSaveState(storage, state) {
    try {
      storage.setItem(CC_STORAGE_KEY, JSON.stringify({ savedAt: Date.now(), state: state }));
    } catch (e) {}
  }

  function initExtensions(section, state, calculate, goToStep) {
    var id = section.id.replace('cc-court-calculator-', '');
    var presetSport   = section.dataset.presetSport   || '';
    var presetSurface = section.dataset.presetSurface || '';
    var minAsphalt    = parseInt(section.dataset.minAsphaltSqft || '5000', 10);
    var productTitle  = section.dataset.productTitle  || '';
    var waPhone       = section.dataset.waPhone       || '919258775187';

    var waBtn  = section.querySelector('#cc-calc-wa-' + id);
    var gstExBtn  = section.querySelector('#cc-calc-gst-ex-' + id);
    var gstInBtn  = section.querySelector('#cc-calc-gst-in-' + id);
    var rangeEl   = section.querySelector('#cc-calc-range-' + id);
    var breakEl   = section.querySelector('#cc-calc-breakdown-' + id);
    var asphaltRadio = section.querySelector('.cc-court-calculator__base-radio[value="asphalt"]');
    var existingRadio = section.querySelector('.cc-court-calculator__base-radio[value="existing"]');

    var gstInclusive = false;
    var lastResult = null;

    // ── 6a Product-context binding: pre-select sport + jump to step 2 ────
    if (presetSport) {
      var card = section.querySelector('.cc-court-calculator__sport-card[data-sport="' + presetSport + '"]');
      if (card) card.click();
      // Defer jump to next tick so card-click handlers complete first
      setTimeout(function () {
        if (state.sport) goToStep(2);
      }, 0);
    }

    // ── 6b localStorage hydration on init ────────────────────────────────
    try {
      var saved = ccLoadState(window.localStorage);
      if (saved && !presetSport) {
        // Only hydrate on non-product (hub) calculator pages
        // to avoid overriding the product preset.
        if (saved.sport) {
          var savedCard = section.querySelector('.cc-court-calculator__sport-card[data-sport="' + saved.sport + '"]');
          if (savedCard) savedCard.click();
        }
      }
    } catch (e) {}

    // ── 6b localStorage save on any state change ─────────────────────────
    function saveStateNow() {
      try { ccSaveState(window.localStorage, state); } catch (e) {}
    }
    section.addEventListener('click', saveStateNow, true);
    section.addEventListener('change', saveStateNow, true);

    // ── 6c Asphalt threshold: disable asphalt when area below min ────────
    function updateAsphaltAvailability() {
      if (!asphaltRadio) return;
      var variant = state.variant;
      // PRICING.court_areas is in outer closure — recompute via calculate's logic
      // For threshold check, use a quick lookup by recomputing.
      // Note: We do this after step 2 (variant selected) before step 4 renders.
      // Easiest: derive area from PRICING via a lightweight call.
      var areaPerCourt = window.__ccPricing && window.__ccPricing.court_areas && variant
        ? (window.__ccPricing.court_areas[variant] || 0)
        : 0;
      var totalArea = areaPerCourt * (state.count || 1);
      var available = ccIsAsphaltAvailable(totalArea, minAsphalt);
      var optionLabel = asphaltRadio.closest('.cc-court-calculator__base-option');
      if (available) {
        asphaltRadio.disabled = false;
        if (optionLabel) {
          optionLabel.classList.remove('--disabled');
          optionLabel.removeAttribute('title');
        }
      } else {
        asphaltRadio.disabled = true;
        if (asphaltRadio.checked) {
          asphaltRadio.checked = false;
          state.base = null;
        }
        if (optionLabel) {
          optionLabel.classList.add('--disabled');
          optionLabel.setAttribute('title', 'Asphalt becomes cost-effective at ' + minAsphalt.toLocaleString('en-IN') + '+ sqft. PCC is the recommended base below this size.');
        }
      }
    }
    // Hook into navigation: when we arrive at step 4, recheck threshold.
    var origNextBtn = section.querySelector('#cc-calc-next-' + id);
    if (origNextBtn) {
      origNextBtn.addEventListener('click', function () {
        // Allow the original handler to advance step first, then check.
        setTimeout(updateAsphaltAvailability, 0);
      });
    }

    // ── 6d Existing base: emit cc:variant-changed so cc-existing-base-info reveals
    section.querySelectorAll('.cc-court-calculator__base-radio').forEach(function (radio) {
      radio.addEventListener('change', function () {
        // bubbles to document so cc-existing-base-info listener catches it
        document.dispatchEvent(new CustomEvent('cc:variant-changed', {
          bubbles: true,
          detail: { base: radio.value, option2: radio.value, source: 'calculator' }
        }));
      });
    });

    // ── 6e GST toggle: recompute result display ──────────────────────────
    function renderWithGST() {
      if (!lastResult || !rangeEl || !breakEl) return;
      var lowGST  = ccApplyGST(lastResult.totalMin, gstInclusive);
      var highGST = ccApplyGST(lastResult.totalMax, gstInclusive);
      rangeEl.textContent = formatINR(lowGST.total) + ' – ' + formatINR(highGST.total)
        + (gstInclusive ? ' incl. GST' : ' ex-GST');
    }
    if (gstExBtn && gstInBtn) {
      gstExBtn.addEventListener('click', function () {
        gstInclusive = false;
        gstExBtn.classList.add('--active'); gstExBtn.setAttribute('aria-pressed', 'true');
        gstInBtn.classList.remove('--active'); gstInBtn.setAttribute('aria-pressed', 'false');
        renderWithGST();
      });
      gstInBtn.addEventListener('click', function () {
        gstInclusive = true;
        gstInBtn.classList.add('--active'); gstInBtn.setAttribute('aria-pressed', 'true');
        gstExBtn.classList.remove('--active'); gstExBtn.setAttribute('aria-pressed', 'false');
        renderWithGST();
      });
    }

    // ── 6f WhatsApp dynamic URL: rebuild after each calculate ────────────
    function updateWhatsAppLink() {
      if (!waBtn) return;
      var result = calculate();
      lastResult = result;
      // Derive friendly labels from data attrs + state
      var sportLabel = (presetSport || state.sport || '').replace(/_/g, ' ').replace(/^./, function (c) { return c.toUpperCase(); });
      var surfaceLabel = (presetSurface || state.surface || '').replace(/_/g, ' ').replace(/^./, function (c) { return c.toUpperCase(); });
      var baseLabel = (state.base || '').toUpperCase();
      var url = ccBuildWhatsAppUrl({
        phone: waPhone,
        productTitle: productTitle,
        sport: sportLabel,
        surface: surfaceLabel,
        base: baseLabel,
        count: state.count,
        area: result.area,
        addons: state.addons,
        totalMin: result.totalMin,
        totalMax: result.totalMax
      });
      waBtn.setAttribute('href', url);
    }

    // Hook into result panel reveal: when next becomes "Calculate" and is clicked
    // showResult() runs (in core code) — refresh WA link + GST display right after.
    var resultObserver = new MutationObserver(function () {
      var resultEl = section.querySelector('#cc-calc-result-' + id);
      if (resultEl && !resultEl.hasAttribute('hidden')) {
        updateWhatsAppLink();
        renderWithGST();
      }
    });
    var resultEl = section.querySelector('#cc-calc-result-' + id);
    if (resultEl) resultObserver.observe(resultEl, { attributes: true, attributeFilter: ['hidden'] });
  }

  // Expose PRICING on window so extension can read court areas for asphalt check.
  // This is a small surface-area increase but avoids invasive refactor.
  window.__ccPricing = PRICING;

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-dimension-guide"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  /**
   * cc-dimension-guide — configuration switcher
   *
   * Reads data-config on each tab button.
   * On activate:
   *   1. Marks the clicked tab button as active (aria + class)
   *   2. Shows the matching .cc-dim-detail panel (right column)
   *   3. Shows the matching .cc-dim-annotation group (SVG overlay)
   *   4. Highlights the matching .cc-dimension-guide__tr row in the table
   *   5. Highlights the matching .cc-dimension-guide__mobile-card
   */
  function initDimensionGuide(section) {
    var tabs        = section.querySelectorAll('.cc-dimension-guide__tab');
    var details     = section.querySelectorAll('.cc-dim-detail');
    var courtSvgs   = section.querySelectorAll('.cc-dimension-guide__court-svg');
    var tableRows   = section.querySelectorAll('.cc-dimension-guide__tr');
    var mobileCards = section.querySelectorAll('.cc-dimension-guide__mobile-card');

    if (!tabs.length) return;

    function activate(config) {
      // ── Tabs ──
      tabs.forEach(function (btn) {
        var isActive = btn.dataset.config === config;
        btn.classList.toggle('cc-dimension-guide__tab--active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      // ── Detail panels ──
      details.forEach(function (panel) {
        panel.classList.toggle('cc-dim-detail--hidden', panel.dataset.detail !== config);
      });

      // ── Court SVG variants (basketball has multiple; other sports have none) ──
      if (courtSvgs.length > 0) {
        var svgConfig = config === 'custom' ? 'fiba-full' : config;
        courtSvgs.forEach(function (wrap) {
          wrap.classList.toggle('cc-dimension-guide__court-svg--hidden', wrap.dataset.courtSvg !== svgConfig);
        });
      }

      // ── Table rows ──
      tableRows.forEach(function (row) {
        row.classList.toggle('cc-dimension-guide__tr--active', row.dataset.row === config);
      });

      // ── Mobile cards ──
      mobileCards.forEach(function (card) {
        card.classList.toggle('cc-dimension-guide__mobile-card--active', card.dataset.mobileCard === config);
      });
    }

    // Click handler
    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(btn.dataset.config);
      });
    });

    // Roving tabindex keyboard navigation (left/right arrows)
    tabs.forEach(function (btn, idx) {
      btn.addEventListener('keydown', function (e) {
        var next;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          next = tabs[(idx + 1) % tabs.length];
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          next = tabs[(idx - 1 + tabs.length) % tabs.length];
        } else if (e.key === 'Home') {
          next = tabs[0];
        } else if (e.key === 'End') {
          next = tabs[tabs.length - 1];
        }
        if (next) {
          e.preventDefault();
          next.focus();
          activate(next.dataset.config);
        }
      });
    });

    // ── Custom size calculator (event delegation — more robust) ──
    function calcCustom() {
      var lEl = section.querySelector('[data-custom="length"]');
      var wEl = section.querySelector('[data-custom="width"]');
      var rEl = section.querySelector('[data-custom="runoff"]');
      if (!lEl || !wEl) return;

      var lengthM = parseFloat(lEl.value) || 0;
      var widthM  = parseFloat(wEl.value) || 0;
      var runoffM = rEl ? (parseFloat(rEl.value) || 0) : 0;

      var dimsFt  = section.querySelector('[data-custom-result="dims-ft"]');
      var areaEl  = section.querySelector('[data-custom-result="area"]');
      var totalEl = section.querySelector('[data-custom-result="total-area"]');
      if (!dimsFt || !areaEl || !totalEl) return;

      if (lengthM > 0 && widthM > 0) {
        var lFt = (lengthM * 3.28084).toFixed(1);
        var wFt = (widthM * 3.28084).toFixed(1);
        var areaSqft  = Math.round(lengthM * widthM * 10.7639);
        var totalL    = lengthM + (runoffM * 2);
        var totalW    = widthM + (runoffM * 2);
        var totalSqft = Math.round(totalL * totalW * 10.7639);

        dimsFt.textContent  = lFt + ' \u00d7 ' + wFt + ' ft';
        areaEl.textContent  = areaSqft.toLocaleString('en-IN') + ' sqft';
        totalEl.textContent = totalSqft.toLocaleString('en-IN') + ' sqft';

        // Flash highlight
        var wrap = section.querySelector('[data-custom-results]');
        if (wrap) {
          wrap.classList.add('cc-dim-detail__cards--flash');
          setTimeout(function () { wrap.classList.remove('cc-dim-detail__cards--flash'); }, 600);
        }
      } else {
        dimsFt.textContent  = '\u2014 \u00d7 \u2014 ft';
        areaEl.textContent  = '\u2014 sqft';
        totalEl.textContent = '\u2014 sqft';
      }
    }

    // Event delegation: catch clicks on Calculate button and Enter in inputs
    section.addEventListener('click', function (e) {
      if (e.target.closest('.cc-dim-custom-calc-btn')) {
        e.preventDefault();
        calcCustom();
      }
    });
    section.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.classList.contains('cc-dim-custom-input')) {
        e.preventDefault();
        calcCustom();
      }
    });

    // ── Color Picker ──
    var COLOR_PALETTES = {
      pp_tiles: [
        { name: 'Red', hex: '#D72F18' },
        { name: 'Green', hex: '#3E8B56' },
        { name: 'Dark Green', hex: '#1B5E20' },
        { name: 'Yellow', hex: '#E19303' },
        { name: 'Grey', hex: '#908E84' },
        { name: 'Blue', hex: '#2F8ADD' },
        { name: 'Dark Blue', hex: '#3C62C4' },
        { name: 'Orange', hex: '#E46610' }
      ],
      acrylic: [
        { name: 'Terracotta Red', hex: '#C84C31' },
        { name: 'Grass Green', hex: '#4CAF50' },
        { name: 'Dark Green', hex: '#1B5E20' },
        { name: 'Grey', hex: '#78909C' },
        { name: 'Light Blue', hex: '#42A5F5' },
        { name: 'Royal Blue', hex: '#1565C0' },
        { name: 'Dark Blue', hex: '#0D47A1' }
      ]
    };

    var KEY_DEFAULTS = {
      '#D72F18': '#2F8ADD', '#3E8B56': '#D72F18', '#1B5E20': '#D72F18',
      '#E19303': '#2F8ADD', '#908E84': '#D72F18', '#2F8ADD': '#D72F18',
      '#3C62C4': '#D72F18', '#E46610': '#2F8ADD',
      '#C84C31': '#1565C0', '#4CAF50': '#C84C31', '#78909C': '#C84C31',
      '#42A5F5': '#C84C31', '#1565C0': '#C84C31', '#0D47A1': '#C84C31'
    };

    var pickerEl = section.querySelector('[data-color-picker]');
    var selectedColors = { surface: null, key: null, surfaceType: 'pp_tiles' };

    function renderSwatches(role, palette) {
      var grid = section.querySelector('[data-color-role="' + role + '"]');
      if (!grid) return;
      grid.innerHTML = '';
      palette.forEach(function (c) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cc-dim-color-swatch';
        btn.style.backgroundColor = c.hex;
        btn.setAttribute('data-color-hex', c.hex);
        btn.setAttribute('data-color-name', c.name);
        btn.setAttribute('aria-label', c.name);
        btn.title = c.name;
        btn.addEventListener('click', function () { selectColor(role, c.hex, c.name); });
        grid.appendChild(btn);
      });
    }

    function selectColor(role, hex, name) {
      selectedColors[role] = { hex: hex, name: name };
      // Update swatch active state
      var grid = section.querySelector('[data-color-role="' + role + '"]');
      grid.querySelectorAll('.cc-dim-color-swatch').forEach(function (s) {
        s.classList.toggle('cc-dim-color-swatch--active', s.dataset.colorHex === hex);
      });
      // Update label
      var label = section.querySelector('[data-color-label="' + role + '"]');
      if (label) label.textContent = name;
      // Auto-select key color when surface changes
      if (role === 'surface' && KEY_DEFAULTS[hex]) {
        var keyHex = KEY_DEFAULTS[hex];
        var keyPalette = COLOR_PALETTES[selectedColors.surfaceType];
        var keyColor = keyPalette.find(function (c) { return c.hex === keyHex; });
        if (keyColor) selectColor('key', keyColor.hex, keyColor.name);
      }
      // Apply to SVG
      applyColorsToSvg();
    }

    function applyColorsToSvg() {
      // Find the currently visible court SVG wrapper
      var visibleSvg = section.querySelector('.cc-dimension-guide__court-svg:not(.cc-dimension-guide__court-svg--hidden)');
      if (!visibleSvg) visibleSvg = section.querySelector('.cc-dimension-guide__diagram-wrap');
      if (!visibleSvg) return;

      if (selectedColors.surface) {
        // Color the court surface backdrop rect
        visibleSvg.querySelectorAll('[data-court-surface]').forEach(function (el) {
          el.setAttribute('fill', selectedColors.surface.hex);
          el.setAttribute('fill-opacity', '0.7');
        });
      }
      if (selectedColors.key) {
        // Color the paint/key zone rects
        visibleSvg.querySelectorAll('[data-court-key]').forEach(function (el) {
          el.setAttribute('fill', selectedColors.key.hex);
          el.setAttribute('fill-opacity', '0.6');
        });
      }
    }

    if (pickerEl) {
      // Init swatches
      renderSwatches('surface', COLOR_PALETTES.pp_tiles);
      renderSwatches('key', COLOR_PALETTES.pp_tiles);

      // Surface type toggle
      section.querySelectorAll('.cc-dim-color-surface-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          section.querySelectorAll('.cc-dim-color-surface-btn').forEach(function (b) {
            b.classList.remove('cc-dim-color-surface-btn--active');
          });
          btn.classList.add('cc-dim-color-surface-btn--active');
          selectedColors.surfaceType = btn.dataset.surfaceType;
          selectedColors.surface = null;
          selectedColors.key = null;
          var palette = COLOR_PALETTES[btn.dataset.surfaceType];
          renderSwatches('surface', palette);
          renderSwatches('key', palette);
          section.querySelector('[data-color-label="surface"]').textContent = 'Select a color';
          section.querySelector('[data-color-label="key"]').textContent = 'Select a color';
        });
      });
    }

    // ── Form pre-fill on CTA click ──
    var configData = {
      'fiba-full':  { name: 'FIBA Full Court', dims: '28m \u00d7 15m', area: '4,600 sqft', total: '7,200 sqft' },
      'half-court': { name: 'Half Court', dims: '15m \u00d7 14m', area: '2,300 sqft', total: '3,200 sqft' },
      '3x3':        { name: '3\u00d73 Court', dims: '15m \u00d7 11m', area: '1,750 sqft', total: '2,400 sqft' },
      'nba-full':   { name: 'NBA Full Court', dims: '28.65m \u00d7 15.24m', area: '4,700 sqft', total: '7,200 sqft' }
    };

    section.querySelectorAll('[data-action="prefill-inquiry"]').forEach(function (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();

        // Determine active config
        var activeTab = section.querySelector('.cc-dimension-guide__tab--active');
        var config = activeTab ? activeTab.dataset.config : 'fiba-full';

        var lines = [];
        if (config === 'custom') {
          var lm = section.querySelector('[data-custom="length"]').value || '—';
          var wm = section.querySelector('[data-custom="width"]').value || '—';
          var dimsFt = section.querySelector('[data-custom-result="dims-ft"]').textContent;
          var area   = section.querySelector('[data-custom-result="area"]').textContent;
          var total  = section.querySelector('[data-custom-result="total-area"]').textContent;
          lines.push('Custom Court Inquiry');
          lines.push('Dimensions: ' + lm + 'm \u00d7 ' + wm + 'm (' + dimsFt + ')');
          lines.push('Playing Area: ' + area);
          lines.push('Total with Run-off: ' + total);
        } else if (configData[config]) {
          var cd = configData[config];
          lines.push(cd.name + ' Inquiry');
          lines.push('Dimensions: ' + cd.dims);
          lines.push('Playing Area: ' + cd.area);
          lines.push('Total with Run-off: ' + cd.total);
        }

        // Add color selection
        if (selectedColors.surface) {
          var surfaceLabel = selectedColors.surfaceType === 'acrylic' ? 'Acrylic' : 'PP Tiles';
          lines.push('Surface: ' + surfaceLabel);
          lines.push('Court Color: ' + selectedColors.surface.name);
          if (selectedColors.key) lines.push('Key Color: ' + selectedColors.key.name);
        }

        // Add notes
        var notes = section.querySelector('[data-custom="notes"]');
        if (notes && notes.value.trim()) {
          lines.push('Notes: ' + notes.value.trim());
        }

        var message = lines.join('\n');

        // Find the hero form's body field and populate
        var bodyField = document.querySelector('input[name="contact[body]"]');
        if (bodyField) {
          bodyField.value = message;
        }

        // Scroll to the hero form
        var heroForm = document.querySelector('.cc-hero-sport__form-card');
        if (heroForm) {
          heroForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
          heroForm.classList.add('cc-hero-sport__form-card--highlight');
          setTimeout(function () { heroForm.classList.remove('cc-hero-sport__form-card--highlight'); }, 2000);
        }
      });
    });

    // Re-apply colors when switching tabs (SVG changes)
    var origActivate = activate;
    activate = function (config) {
      origActivate(config);
      setTimeout(applyColorsToSvg, 50);
    };

    // Initialise with first tab
    var firstConfig = tabs[0] && tabs[0].dataset.config;
    if (firstConfig) activate(firstConfig);
  }

  function init() {
    document.querySelectorAll('.cc-dimension-guide').forEach(function (section) {
      initDimensionGuide(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-existing-base-info"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // Heuristic: match strings like "Existing Base", "I have a base", "existing", etc.
  function isExistingBase(val) {
    if (!val) return false;
    var v = val.toString().toLowerCase();
    return v.indexOf('existing') !== -1 || v.indexOf('i have') !== -1 || v.indexOf('own base') !== -1;
  }

  document.querySelectorAll('.cc-existing-base-info').forEach(function (section) {
    // Listen for variant changes from cc-product-configurator (bubbles up to document)
    document.addEventListener('cc:variant-changed', function (e) {
      var detail = e.detail || {};
      var reveal = isExistingBase(detail.option2) || isExistingBase(detail.base);
      section.classList.toggle('--visible', reveal);
      section.setAttribute('aria-hidden', reveal ? 'false' : 'true');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-product-configurator"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function formatINR(paise) {
    var rupees = Math.round(paise / 100);
    var str = rupees.toString();
    var lastThree = str.substring(str.length - 3);
    var remaining = str.substring(0, str.length - 3);
    if (remaining !== '') lastThree = ',' + lastThree;
    return '₹' + remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
  }

  function findMatchingVariant(variants, sel) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.option1 === sel.option1 && v.option2 === sel.option2) return v;
    }
    return null;
  }

  document.querySelectorAll('.cc-product-configurator').forEach(function (section) {
    var sectionId = section.dataset.sectionId;
    var dataEl = section.querySelector('#cc-pc-data-' + sectionId);
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selected = Object.assign({}, data.selected);
    var priceEl = section.querySelector('[data-cc-price]');

    function emit(detail) {
      section.dispatchEvent(new CustomEvent('cc:variant-changed', {
        bubbles: true,
        detail: detail
      }));
    }

    function update() {
      var match = findMatchingVariant(data.variants, selected);
      if (priceEl && match) {
        priceEl.classList.add('--updating');
        priceEl.textContent = formatINR(match.price);
        setTimeout(function () { priceEl.classList.remove('--updating'); }, 250);
      }
      emit({
        productId: parseInt(section.dataset.productId, 10),
        productHandle: section.dataset.productHandle,
        variantId: match ? match.id : null,
        available: match ? match.available : false,
        option1: selected.option1,
        option2: selected.option2,
        price: match ? match.price : null,
        base: (selected.option2 || '').toLowerCase()
      });
    }

    section.querySelectorAll('.cc-product-configurator__choice').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.dataset.ccOptionIndex, 10);
        var val = btn.dataset.ccOptionValue;

        // Deselect siblings in the same group
        var siblings = btn.closest('.cc-product-configurator__choices')
          .querySelectorAll('.cc-product-configurator__choice');
        siblings.forEach(function (s) {
          s.setAttribute('aria-checked', 'false');
          s.setAttribute('aria-pressed', 'false');
        });
        btn.setAttribute('aria-checked', 'true');
        btn.setAttribute('aria-pressed', 'true');

        if (idx === 0) selected.option1 = val;
        if (idx === 1) selected.option2 = val;

        update();
      });

      // Keyboard arrow nav for radio behavior
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
        e.preventDefault();
        var group = btn.closest('.cc-product-configurator__choices');
        var btns = Array.prototype.slice.call(group.querySelectorAll('.cc-product-configurator__choice'));
        var i = btns.indexOf(btn);
        if (i < 0) return;
        var nextIdx = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? (i + 1) % btns.length : (i - 1 + btns.length) % btns.length;
        btns[nextIdx].focus();
        btns[nextIdx].click();
      });
    });

    // Fire initial emit so listeners can sync with default selection
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
